import axios from 'axios';
import React, { useContext, useRef, useState } from 'react';
import { DataContext } from '../context/data';

export const Accueil = () => {

    const { token, setDataAPI, isLoaded, setIsLoaded, setIdentifiantCR } = useContext(DataContext)

    const form = useRef()

    const [identifiant, setIdentifiant] = useState()

    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiIsImtpZCI6IjI4YTMxOGY3LTAwMDAtYTFlYi03ZmExLTJjNzQzM2M2Y2NhNSJ9.eyJpc3MiOiJzdXBlcmNlbGwiLCJhdWQiOiJzdXBlcmNlbGw6Z2FtZWFwaSIsImp0aSI6IjhlYjk0NTZiLWI0N2YtNDZlZi05ZDAxLTgyMjQ2MTc3Yjg5OCIsImlhdCI6MTY0NDE3NDg5NCwic3ViIjoiZGV2ZWxvcGVyLzZjY2I3ODY4LWIwOTEtZDM5OC04ZWNjLTBkMDlmZWRhZjkwMiIsInNjb3BlcyI6WyJyb3lhbGUiXSwibGltaXRzIjpbeyJ0aWVyIjoiZGV2ZWxvcGVyL3NpbHZlciIsInR5cGUiOiJ0aHJvdHRsaW5nIn0seyJjaWRycyI6WyIxMjguMTI4LjEyOC4xMjgiXSwidHlwZSI6ImNsaWVudCJ9XX0.6G7ttw6XVe-XtvIoM9EgWNqfWEVtnLc5fw2XscHJgTt81FaS7N1g9JYY1CxoG0NVn6XWHL8gengP-HyS6R-PLg'
    const url = 'https://proxy.royaleapi.dev/v1/players/%23'

    function sendForm(e) {
        e.preventDefault()

        let identifiantClean = identifiant;

        identifiantClean = identifiantClean.replace('#', '');
        console.log(identifiantClean);



        // setIdentifiant(identifiant.replace(/\b\#\w+/g, ''));
        // console.log(identifiant);
        axios.get(url + identifiantClean, { headers: { 'Authorization': `Bearer ${token}` } }).then(res => {
            // console.log(res.data);
            setIsLoaded(true)
            setDataAPI(res.data)
            setIdentifiantCR(identifiantClean)
            
        })

    }
    if (!isLoaded) {

        return (
            <div>
                <h1>Entrez votre identifiant</h1>
                <div className="row">
                    <form ref={form} onSubmit={sendForm} className="col s12">
                        <div className="row">
                            <div className="input-field col s12 l3">
                                {/* <i className="material-icons prefix">account_circle</i> */}
                                <input id="icon_prefix" type="text" className="validate" onChange={(e) => { setIdentifiant(e.target.value) }} />
                                <label htmlFor="icon_prefix">Identifiant</label>
                            </div>
                        </div>
                            <button className="btn waves-effect waves-light">Envoyer</button>
                    </form>
                </div>
            </div>);
    }
    else {
        return (
            <div>
                Donnée chargé
            </div>
        )
    }
};
